import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

import { getEquipmentLabel } from '~components/Filters/useFetchers';
import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { BasicEquipment } from '~hooks/useEquipment/models';
import { JobInvoicing } from '~hooks/useJob/models';

import { NO_VALUE_PLACEHOLDER } from '../chargesGrid';

interface ChargesTruckCellProps {
  job: JobInvoicing;
  sx?: SxProps<Theme>;
}

export default function ChargesTruckCell({ job, sx }: ChargesTruckCellProps) {
  const labels = [job.equipment, job.additionalEquipment]
    .filter((item): item is BasicEquipment => Boolean(item))
    .map(getEquipmentLabel);

  return (
    <Box data-test-id="charges-truck-cell" sx={sx}>
      {labels.length === 0 ? (
        <OverflowAwareText>{NO_VALUE_PLACEHOLDER}</OverflowAwareText>
      ) : (
        labels.map((label) => (
          <Box key={label}>
            <OverflowAwareText title={label}>{label}</OverflowAwareText>
          </Box>
        ))
      )}
    </Box>
  );
}
